export default "__VITE_ASSET__DuHYl6Aw__"